import React, { ReactNode, useMemo } from "react";
import { ThemeProvider } from "@mui/material/styles";
import { getTheme } from "./wscTheme";
import GlobalStyles from "@mui/material/GlobalStyles";
import { CssBaseline } from "@mui/material";

// The CssBaseline component helps to kickstart an elegant, consistent, and simple baseline to build upon.
interface ThemeProps {
  children: ReactNode | ReactNode[];
  isPrimaryYellow?: boolean;
}

export default function WscThemeProvider({
  children,
  isPrimaryYellow = false,
}: ThemeProps) {
  const theme = useMemo(() => getTheme(isPrimaryYellow), [isPrimaryYellow]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles
        styles={{
          textArea: {
            fontFamily: `"Inter","Helvetica","Arial",sans-serif`,
          },
        }}
      />
      {children}
    </ThemeProvider>
  );
}

//TODO: DON'T USE ABSOLUTE IMPORT! Will be replaced in future, use useTheme() or ${({ theme }) => theme.wsc...} instead.
export { wscTheme, wscThemeYellow } from "./wscTheme";
